export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
}

export const durationUnitRegex = /[a-zA-Z]/;
export const calculateRgba = (color, opacity) => {
  if (color[0] === "#") {
    color = color.slice(1);
  }
  if (color.length === 3) {
    let res = "";
    color.split("").forEach((c) => {
      res += c;
      res += c;
    });
    color = res;
  }
  const rgbValues = (color.match(/.{2}/g) || [])
    .map((hex) => parseInt(hex, 16))
    .join(", ");
  return `rgba(${rgbValues}, ${opacity})`;
};
export const range = (size, startAt = 0) =>
  [...Array(size).keys()].map((i) => i + startAt);

/**
 * Change the URL and let your router pick it up.
 *
 * @param {string} url     the new URL (path + query) you want to show
 * @param {boolean} replace  if true, do replaceState; otherwise pushState
 */
export function goTo(url, replace = false) {
  if (replace) {
    window.history.replaceState({}, '', url);
  } else {
    window.history.pushState({}, '', url);
  }
  // manually fire popstate so your SPA‐router notices:
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/**
 * The backend sends primeTime packs ahead of their startAt (unlike regular packs,
 * which are only sent once live). A primeTime pack must stay hidden — and must not
 * replace the regular gold packs — until startAt passes, because init-payment
 * rejects packs that are not live yet.
 */
export function isPrimetimePendingStart(pack, now = Date.now()) {
  const isPrimetime = pack.primeTime || pack.specialTitle?.toLowerCase().includes('primetime');
  return !!(isPrimetime && pack.startAt && new Date(pack.startAt).getTime() > now);
}

/**
 * Earliest upcoming pack transition: an active pack expiring (endAt) or a pending
 * primeTime pack going live (startAt). Returns a timestamp, or null if none.
 */
export function getNextPackTransition(packs, now = Date.now()) {
  const times = [];
  for (const pack of packs || []) {
    if (pack.endAt) {
      const endAt = new Date(pack.endAt).getTime();
      if (endAt > now) times.push(endAt);
    }
    if (isPrimetimePendingStart(pack, now)) {
      times.push(new Date(pack.startAt).getTime());
    }
  }
  return times.length > 0 ? Math.min(...times) : null;
}

